import React, { createContext, useContext } from 'react';
import { useHomePage } from '../hooks/useHomePage';

const HomePageContext = createContext(null);

// 추후 Props drilling 개선하면 좋을듯함
export const HomePageProvider = ({ children }) => {
  const homePage = useHomePage();
  return <HomePageContext.Provider value={homePage}>{children}</HomePageContext.Provider>;
};

export const useHomePageContext = () => {
  const context = useContext(HomePageContext);
  if (!context) throw new Error('useHomePageContext must be used within HomePageProvider');
  return context;
};
